import { jsxs as m, jsx as e } from "react/jsx-runtime";
import { c as N } from "./index.rKuIKazb.js";
import c from "react";
import { s as C, F as I, a as j } from "./field-error.DDRV9OmH.js";
import { Flex as _ } from "../flex.js";
import { Label as v } from "../label.js";
import { L as l } from "./layout.BROMuy9M.js";
import '../assets/field.css';const w = "_field_hr4mt_3", y = "_element_hr4mt_9", L = "_trailing_hr4mt_12", k = "_label_hr4mt_18", E = "_input_hr4mt_22", R = "_disabled_hr4mt_29", q = "_textarea_hr4mt_32", z = "_invalid_hr4mt_45", t = {
  field: w,
  element: y,
  trailing: L,
  label: k,
  input: E,
  disabled: R,
  textarea: q,
  invalid: z
}, A = ({
  id: h,
  label: p,
  caption: s,
  error: a,
  trailing: r,
  invalid: i,
  disabled: d,
  children: f,
  element: u,
  className: b,
  ...g
}) => {
  const F = c.useId(), n = h || F, o = c.useId(), x = N(
    t.field,
    t[u || "input"],
    {
      [t.invalid]: i,
      [t.disabled]: d
    },
    b
  );
  return /* @__PURE__ */ m("div", { ...g, children: [
    /* @__PURE__ */ e(_, { className: x, direction: "column", padding: { top: 400 }, children: /* @__PURE__ */ m(_, { direction: "row", justifyContent: "space-between", children: [
      /* @__PURE__ */ e(l, { padding: { left: 100 }, asChild: !0, children: /* @__PURE__ */ e(v, { htmlFor: n, className: t.label, disabled: d, children: p }) }),
      /* @__PURE__ */ e(
        l,
        {
          id: n,
          padding: { left: 100, bottom: 100 },
          width: "full",
          className: t.element,
          asChild: !0,
          ...C({
            ...i && { "aria-invalid": !0 },
            ...i && { "aria-errormessage": o }
          }),
          children: f
        }
      ),
      r && /* @__PURE__ */ e(l, { className: t.trailing, asChild: !0, children: r })
    ] }) }),
    (a || s) && /* @__PURE__ */ e(l, { margin: { left: 100, top: 100 }, children: a ? /* @__PURE__ */ e(I, { id: o, children: a }) : /* @__PURE__ */ e(j, { invalid: i, children: s }) })
  ] });
};
A.displayName = "Field";
export {
  A as F
};
//# sourceMappingURL=field.CyPGgOAN.js.map
